import CardQueueDataGrid from "../CardQueueDataGrid";
export default class CardQueueDataGridNotification extends CardQueueDataGrid {
  columns = {
    "notification.id": {
      type: "number",
      name: "ID",
      width: 110,
    },
    "notification.patient_id": {
      type: "number",
      name: "Patient ID",
      width: 120,
    },
    "notification.order_activity_id": {
      type: "number",
      name: "Order #",
      width: 120,
    },
    "notification.notification_type_term_id": {
      type: "term",
      name: "Type",
      width: 270,
    },
    "notification.userprofile_id": {
      type: "user",
      name: "User",
      width: 80,
    },
    "notification.delivery_min": {
      type: "datetime",
      name: "Delivery Min",
      width: 160,
    },
    "notification.delivery_max": {
      type: "datetime",
      name: "Delivery Max",
      width: 160,
    },
    "notification.sender": {
      type: "string",
      name: "Sender",
      width: 240,
    },
    "notification.recipient": {
      type: "string",
      name: "Recipient",
      width: 120,
    },
    "notification.notification_status_term_id": {
      type: "term",
      name: "Status",
      width: 120,
    },
    "notification.notification_channel_term_id": {
      type: "term",
      name: "Channel",
      width: 120,
    },
    "notification.last_notification_status_term_id_change": {
      type: "datetime",
      name: "Status Change",
      width: 160,
    },
    "notification.created_at": {
      type: "datetime",
      name: "Created At",
      width: 160,
    },
    "notification.content": {
      type: "stringTooltip",
      name: "Content",
      width: 250,
    },
    out_of_bounds: {
      type: "boolean",
      name: "OOB",
      width: 80,
    },
  };

  /**
   * Handle clicking on a grid row.
   */
  handleClickRow(row) {
    if (this.props.onClickRow) {
      this.props.onClickRow();
    }

    this.openOrder(row);
  }

  /**
   * Opens the order.
   *
   * @param {Object} row The grid row.
   */
  openOrder(row) {
    if (row["notification.order_activity_id"]) {
      window.open(
        `/chart/${row["notification.patient_id"]}/order/${row["notification.order_activity_id"]}`,
        "_blank",
      );
    } else if (row["notification.patient_id"]) {
      window.open(`/chart/${row["notification.patient_id"]}`, "_blank");
    }
  }
}
